// test1371
(1371 && 0);
